import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreviewDispatchService {
  protected sectionThumnails = new BehaviorSubject<any[]>(null)
  protected gridCellIds: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null)
  protected cellIdsThumbs: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  constructor() { }
  /**
   *
   * @param selectedEl HTMLElement to be edited;
   * Sets the sectionThumnails and the cellIdsThumbs Observables
   */
  setEditElement(selectedEl: HTMLElement): void {
    // const selectedEl = parentEl.querySelector('#'+targetEl);
    console.log(selectedEl)
    const rendererType = selectedEl.getAttribute('renderer-type');
    console.log(rendererType);
    // const section = selectedEl.getAttribute('ng-reflect-section');
    // console.log(section);
    const numberOfElements = selectedEl.getAttribute('number-of-elements');
    // console.log(numberOfElements);
    const sectionThumbnails: any[] = [];
    const gridCellIds: string[] = [];
    const cellIdsThumbs: any[] = [];

    if (rendererType != undefined) {
      switch (rendererType) {
        case "GRID":
        case "grid":
          // let gridCells = selectedEl.querySelectorAll('.grid-cell-container');
          const gridCells = this.setGridCells(selectedEl);

          if (gridCells != undefined) {
            // console.log(gridCells);
            gridCells.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              const content = cell.getAttribute('content');
              const contentEnum = cell.getAttribute('content-enum') || 'undefined';
              let imgSrc = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const images = cell.getElementsByTagName("IMG");
              console.log(images);
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              } else {
                // Check if there's a background image in a child element  with class bg-img-layer and get the source for it if it exists
                const bgLayerEl = cell.querySelector('.bg-img-layer');
                if (bgLayerEl != undefined) {
                  const styles = getComputedStyle(bgLayerEl);
                  const urlString = styles.getPropertyValue("--bg-image");
                  console.log(urlString != undefined);
                  if (urlString) {
                    // Match URL inside url(), excluding the parentheses
                    const match = urlString.match(/url\(['"]?(.*?)['"]?\)/);
                    if (match) {
                      imgSrc = match[1];  // Get the captured group (the URL itself)
                    }
                  }
                  /* if (urlString != undefined) {
                    imgSrc = urlString.match(/https?:\/\/[^\s]+/)[0];
                    console.log(urlString);
                    imgSrc = imgSrc.slice(0, -2);
                    console.log(urlString);
                  } */
                }
              }
              console.log(imgSrc);
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc, content: content ? content : "no-content", contentEnum: contentEnum });
            })
          }
          break;
        case "row":
          const rowCells = this.setGridCells(selectedEl);
          if (rowCells != undefined) {
            rowCells.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              let imgSrc = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const images = cell.getElementsByTagName("IMG");
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              }
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc });
              // console.log(`Track cellIdsThumbs: ${cellId} ${imgSrc}`)
            })

          }
          break
        case "RendererType.BANNER":
        case "banner":
          const bannerCells = this.setGridCells(selectedEl);
          if (bannerCells != undefined) {
            const bannerCell = bannerCells[0];
            console.log(bannerCell);
            const cellId = bannerCell.getAttribute('cell-id');
            // bannerCell.setAttribute("cell-id",cellId);
            let imgSrc = null;
            let urlString = null;
            const styles = getComputedStyle(bannerCell);
            // console.log(styles.getPropertyValue('--bg-image'))
            // console.log(styles);
            // let urlString = styles.getPropertyValue("background");
            // Get the background containing element
            const bgElement = bannerCell.querySelector('.bg-img-layer');
            if (bgElement) {
              const bgStyles = getComputedStyle(bgElement);
              urlString = bgStyles.getPropertyValue("--bg-image");
            } else {
              urlString = styles.getPropertyValue("--bg-image");
            }
            console.log(urlString);
            if (urlString != undefined || urlString != null) {
              const regex = /url\((.*?)\)/;

              const match = urlString.match(regex);
              imgSrc = match ? match[1] : null;
              // imgSrc = urlString.match(/https?:\/\/[^\s]+/)[0];
              // console.log("Before slice",imgSrc)
              // imgSrc = imgSrc.slice(0, -2);
            } else {
              imgSrc = "https://placehold.co/960x320?text=No+Image";
            }
            console.log(imgSrc);
            sectionThumbnails.push(imgSrc);
            cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc });
            console.log("Banner Cell Ids in preview dispatch: ", cellIdsThumbs);
          }
          break
        case "hero-image":
          const heroCells = this.setGridCells(selectedEl);
          if (heroCells != undefined) {
            heroCells.forEach(heroCell => {
              const cellId = heroCell.getAttribute('cell-id');
              const content = heroCell.getAttribute('content');
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              let imgSrc = null;
              const bgLayerEl = heroCell.querySelector('.bg-img-layer');
              const images = heroCell.getElementsByTagName("IMG");
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              } else if (bgLayerEl != undefined) {
                // Check if contains svg
                if (bgLayerEl.classList.contains("svg")) {
                  imgSrc = "https://placehold.co/100x120?text=SVG";
                } else {
                  const styles = getComputedStyle(heroCell);
                  const urlString = styles.getPropertyValue("--bg-image");
                  if (urlString != undefined) {
                    imgSrc = urlString.match(/https?:\/\/[^\s]+/)[0];
                    imgSrc = imgSrc.slice(0, -2);
                  }
                }
              }
              sectionThumbnails.push(imgSrc);
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc, content: content ? content : "no-content" });
            })
          }
          break
        case "store-features":
          const cells = this.setGridCells(selectedEl);
          if (cells != undefined) {
            cells.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              let icon = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const icons = cell.getElementsByTagName("nb-icon");
              if (icons.length > 0) {
                icon = icons[0].getAttribute('icon');
                // console.log(icon);
                sectionThumbnails.push(icon);
              }
              cellIdsThumbs.push({ cellId: cellId, icon: icon });
            })
          }
          break;
        case "testimonials":
          const testimonials = this.setGridCells(selectedEl);
          if (testimonials != undefined) {
            testimonials.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              let imgSrc = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const images = cell.getElementsByTagName("IMG");
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              }
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc });
              // console.log(`Track cellIdsThumbs: ${cellId} ${imgSrc}`)
            })

          }
          break
        case "category":
          const categoryCells = this.setGridCells(selectedEl);
          if (categoryCells != undefined) {
            categoryCells.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              let imgSrc = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const images = cell.getElementsByTagName("IMG");
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              }
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc });
              // console.log(`Track cellIdsThumbs: ${cellId} ${imgSrc}`)
            })

          }
          break
        case "product":
          // let gridCells = selectedEl.querySelectorAll('.grid-cell-container');
          const productCells = this.setGridCells(selectedEl);

          if (productCells != undefined) {
            // console.log(productCells);
            productCells.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              let imgSrc = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const images = cell.getElementsByTagName("IMG");
              // console.log(images);
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              } else {
                imgSrc = "https://placehold.co/405x405?text";
                sectionThumbnails.push(imgSrc);
              }
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc });
            })
          }
          break;

        case "slider":
          // let gridCells = selectedEl.querySelectorAll('.grid-cell-container');
          const slideCells = this.setGridCells(selectedEl);

          if (slideCells != undefined) {
            // console.log(productCells);
            slideCells.forEach(cell => {
              const cellId = cell.getAttribute('cell-id');
              let imgSrc = null;
              if (cellId != undefined) {
                gridCellIds.push(cellId);
              }
              const images = cell.getElementsByTagName("IMG");
              // console.log(images);
              if (images.length > 0) {
                imgSrc = images[0].getAttribute('src');
                // console.log(imgSrc);
                sectionThumbnails.push(imgSrc);
              } else {
                imgSrc = "https://placehold.co/405x405?text=Slide+Image";
                sectionThumbnails.push(imgSrc);
              }
              cellIdsThumbs.push({ cellId: cellId, imgSrc: imgSrc });
            })
          }
          break
        default:
          break;
      }

    }
    // console.log(cellIdsThumbs);
    this.sectionThumnails.next(sectionThumbnails);
    this.cellIdsThumbs.next(cellIdsThumbs);
  }

  getSectionThumbnails(): Observable<any[]> {
    return this.sectionThumnails.asObservable();
  }

  getSectionCellIds(): Observable<string[]> {
    return this.gridCellIds.asObservable();
  }

  getCellIdsThumbs(): Observable<any[]> {
    return this.cellIdsThumbs.asObservable()
  }

  setGridCells(selectedEl: HTMLElement) {
    console.log(selectedEl.querySelectorAll('.grid-cell-container'))
    return selectedEl.querySelectorAll('.grid-cell-container');
  }
}
